export { default } from './FeedbackList';

export {
  TrademarkFeedback,
  getIsPolicyFeedback,
  getIsTrademarkInstance,
  type Feedback,
} from './FeedbackList';
